function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", {
  id: "defs87"
}, /*#__PURE__*/React.createElement("clipPath", {
  id: "kr-a"
}, /*#__PURE__*/React.createElement("path", {
  id: "path84",
  fillOpacity: 0.7,
  d: "M-95.8-.4h682.7v512H-95.8z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "g540",
  transform: "scale(10.66667) rotate(-56.3 33.9 -9.5)"
}, /*#__PURE__*/React.createElement("g", {
  id: "b2"
}, /*#__PURE__*/React.createElement("path", {
  id: "b",
  d: "M-6-26H6v2H-6Zm0 3H6v2H-6Zm0 3H6v2H-6Z"
}), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#b",
  id: "use529",
  width: "100%",
  height: "100%",
  x: 0,
  y: 44
})), /*#__PURE__*/React.createElement("path", {
  id: "path532",
  stroke: "#fff",
  d: "M0 17v10"
}), /*#__PURE__*/React.createElement("path", {
  id: "path534",
  fill: "#cd2e3a",
  d: "M0-12a12 12 0 0 1 0 24Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path536",
  fill: "#0047a0",
  d: "M0-12a12 12 0 0 0 0 24A6 6 0 0 0 0 0Z"
}), /*#__PURE__*/React.createElement("circle", {
  id: "circle538",
  cx: 0,
  cy: -6,
  r: 6,
  fill: "#cd2e3a"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "g546",
  transform: "scale(-10.66667) rotate(56.3 10.9 -33.5)"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#b2",
  id: "use542",
  width: "100%",
  height: "100%",
  x: 0,
  y: 0
}), /*#__PURE__*/React.createElement("path", {
  id: "path544",
  stroke: "#fff",
  d: "M0-23.5v3M0 17v3.5m0 3v3"
}));

var SvgKr = function SvgKr(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "flag-icons-kr",
    viewBox: "0 0 640 480",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    id: "g119",
    fillRule: "evenodd",
    clipPath: "url(#kr-a)",
    transform: "translate(89.8 .4) scale(.9375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path526",
    fill: "#fff",
    d: "M-95.8-.4H587v512H-95.8Z",
    style: {
      strokeWidth: 10.0567
    }
  }), _ref3, _ref4));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgKr, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/kr.3b7a3280.svg";
export { ForwardRef as ReactComponent };